
export const numformatCart = Object.freeze({
    name: "fr",
    decimals: ",",
    thousands: " ",
    currencypos: "right",
    currencysymbol: "€",
    precision: "2",
});

export const planColors = Object.freeze({
    ESSENTIAL: 'secondary-green',
    ADVANCED: 'secondary-blue',
    ENTERPRISE: 'secondary-yellow'
});

export const subscriptionUsesLabels = {
    nbActiveUsers: (use) => {
        return window.i18n.n__('%d utilisateur actif', '%d utilisateurs actifs', use, use);
    },
    nbCustomFields: (use) => {
        return window.i18n.n__('%d champ personnalisé', '%d champs personnalisés', use, use);
    },
    nbDunnings: (use) => {
        return window.i18n.n__('%d relance automatique', '%d relances automatiques', use, use);
    },
    nbPermissionProfiles: (use) => {
        return window.i18n.n__('%d profil de privilèges', '%d profils de privilèges', use, use);
    },
    nbPipelines: (use) => {
        return window.i18n.n__('%d pipeline', '%d pipelines', use, use);
    },
}